import { CopyRight, MainHeader, MainWrapper } from '@ifca-ui/neumorphism'
import AppContext, { AppContextProps } from 'containers/Context/Context'
import { PUBLIC_PATH } from 'containers/Module/Auth/Routes'
import { useLoggedInGuestProfileLazyQuery } from 'generated/graphql'
import React, { ReactNode, useContext, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'
import HotelX from 'assets/images/app-logo-b.svg'
import jwtDecode from 'jwt-decode'
import Background from 'assets/images/HR-Background.jpg'
import Authentication from '@ifca-root/react-component/src/assets/icons/authentication.svg'
import queryString from 'query-string'
import { HotelGuestApp } from './HotelGuestApp'

interface Props {
  children?: ReactNode
}

type GuestBootstrapToken = {
  HotelID?: string
  BookingID?: string
  RegistrationID?: string
  RoomID?: string
}

export const GuestLayout = ({ children }: Props) => {
  const history = useHistory()
  const location = useLocation()
  const { RootState, RootDispatch } = useContext<AppContextProps>(AppContext)

  const urlSearchParams = new URLSearchParams(window.location.search)
  const token = urlSearchParams.get('parameter')

  let item: GuestBootstrapToken | null = null

  try {
    item = token ? jwtDecode<GuestBootstrapToken>(token) : null
  } catch (error) {
    item = null
  }

  const HotelID = item?.HotelID
  const BookingID = item?.BookingID
  const RegistrationID = item?.RegistrationID
  const RoomID = item?.RoomID
  const hasBootstrapToken = Boolean(
    HotelID && ((BookingID && RegistrationID) || RoomID)
  )

  const [loggedInGuestProfileinit] = useLoggedInGuestProfileLazyQuery({
    fetchPolicy: 'network-only',
    onError: error => {
      error.graphQLErrors.map(({ message }) => {
        RootDispatch({
          type: 'OnSnackBar',
          payload: {
            ...RootState.OnSnackBar,
            Open: true,
            Message:
              message === "Session expired, please login again."
                ? 'Token has expired'
                : message,
            onClick: () =>
              RootDispatch({
                type: 'CloseSnackBar',
                payload: {},
              }),
          },
        })

        if (message === "Session expired, please login again.") {
          history.push(PUBLIC_PATH.NOT_FOUND_404)
        }
      })
    },
  })

  // useEffect(() => {
  //   if (!hasBootstrapToken) {
  //     loggedInGuestProfileinit()
  //   }
  // }, [hasBootstrapToken, loggedInGuestProfileinit])

  useEffect(() => {
    if (hasBootstrapToken) return

    const guestLogin = JSON.parse(localStorage.getItem('GuestLoginInfo') || 'null')
    if (!guestLogin?.accessToken) return

    loggedInGuestProfileinit()
  }, [hasBootstrapToken, loggedInGuestProfileinit])

  return (
    <MainWrapper>
      <MainHeader
        sections={{
          header: RootState?.HeaderSection?.header,
          left: RootState?.HeaderSection?.left,
          right: RootState?.HeaderSection?.right,
        }}
      />
      {children}
      <CopyRight title={<img src={HotelX} alt="logo" width={50} />} />
    </MainWrapper>
  )
}
